import { render, staticRenderFns } from "./TDChart.vue?vue&type=template&id=94f87168"
import script from "./TDChart.vue?vue&type=script&lang=js"
export * from "./TDChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports